module.exports = __webpack_public_path__ + "static/media/bars-emoji-neutral.15e46e5e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/bars-emoji-neutral.svg
// module id = 682
// module chunks = 0